import axios from 'axios'
import {Toast, Notify, Loading} from 'vue-ydui/dist/lib.rem/dialog'

axios.defaults.timeout = 10000 // 设置请求超时时间
axios.defaults.retry = 3 // 请求失败重新请求次数
axios.defaults.retryDelay = 500 // 请求失败重新请求间隔时间
axios.defaults.withCredentials = true
/**
 *@date: 2018-08-24 14:55:45
 *@author: jing.fu@gosafenet.com
 *@desc: http request 可以做请求拦截
 */
axios.interceptors.request.use(request => {
    // request.headers = Object.assign({}, request.headers, {
    //   'Access-Control-Allow-Origin': '*'
    // })

    process.env.NODE_ENV === 'production' ? "" : console.log(request)

    return request
  },
  error => {
    return Promise.reject(error)
  })

/**
 *@date: 2018-08-24 15:00:42
 *@author: jing.fu@gosafenet.com
 *@desc: http response
 */
axios.interceptors.response.use(response => {
    process.env.NODE_ENV === 'production' ? "" : console.log(response)

    // if (response.data) {
    //   Notify({
    //     mes: '请求失败，请刷新页面',
    //     duration: 1500
    //   })
    //
    //   return Promise.reject(response)
    // }

    return response
  },
  error => {
    var err_msg = "请求失败，请稍候再试"

    if (error.response !== undefined) {
      let status = error.response.status

      switch (status) {
        case 401: {
          /**
           *@date: 2018-07-27 13:50:15
           *@author: jing.fu@gosafenet.com
           *@desc: 401重新刷新Token并再请求
           */
          // return refreshAccessToken()
          //   .then((ret) => {
          //     error.config.headers.Authorization = `Bearer ${ret}`
          //
          //     error.config.baseURL = ''
          //
          //     return axios(error.config)
          //   })
          err_msg = `未授权(${error.response.statusText})`
          break
        }
        case 403: {
          err_msg = `服务器拒绝请求(${error.response.statusText})`
          break
        }
        case 404: {
          err_msg = `服务器找不到请求资源(${error.response.statusText})`
          break
        }
        case 408: {
          err_msg = `服务器等候请求时发生超时(${error.response.statusText})`
          break
        }
        case 500: {
          err_msg = `服务器内部错误(${error.response.statusText})`
          break
        }
        case 502: {
          err_msg = `服务器网络错误(${error.response.statusText})`
          break
        }
        case 505: {
          err_msg = `HTTP版本不受支持(${error.response.statusText})`
          break
        }
      }

      Notify({
        mes: `${err_msg}`,
        duration: 1500
      })

      return Promise.reject(error)
    }

    var config = error.config

    if (!config || !config.retry) return Promise.reject(error)

    config.__retryCount = config.__retryCount || 0

    if (config.__retryCount >= config.retry) {
      err_msg = '请求失败，请刷新或稍候再试'

      Notify({
        mes: `${err_msg}`,
        duration: 1500
      })

      return Promise.reject(error)
    }

    config.__retryCount += 1

    // Create new promise to handle exponential backoff
    var backoff = new Promise(function (resolve) {
      setTimeout(function () {
        resolve()
      }, config.retryDelay || 1)
    })

    // Return the promise in which recalls axios to retry the request
    return backoff.then(function () {
      return axios(config)
    })
  })

/**
 *@date: 2018-07-27 11:46:40
 *@author: jing.fu@gosafenet.com
 *@desc: 封装get方法
 */
export function fetch (url, options) {
  const data = Object.assign({}, options)

  Loading.open('请稍候')

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios.get(url, {
        params: data
      })
        .then(response => {
          Loading.close()

          response !== undefined ? resolve(response.data) : resolve(null)
        })
        .catch(err => {
          Loading.close()

          reject(err)
        })
    }, 1000)
  })
}

/**
 *@date: 2018-07-27 11:46:40
 *@author: jing.fu@gosafenet.com
 *@desc: 封装post请求
 */
export function post (url, options) {
  const data = Object.assign({}, options)

  Loading.open('请稍候')

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios.post(url, data)
        .then(response => {
          Loading.close()

          response !== undefined ? resolve(response.data) : resolve(null)
        }, err => {
          Loading.close()

          reject(err)
        })
    }, 1000)
  })
}

/**
 *@date: 2018-07-27 11:46:40
 *@author: jing.fu@gosafenet.com
 *@desc: 封装delete请求
 */
export function remove (url, options) {
  const data = Object.assign({}, options)

  Loading.open('请稍候')

  return new Promise((resolve, reject) => {

    setTimeout(() => {

      axios.delete(url, {
        params: data
      })
        .then(response => {
          Loading.close()

          response !== undefined ? resolve(response.data) : resolve(null)

        }, err => {
          Loading.close()

          reject(err)
        })
    }, 1000)
  })
}

/**
 *@date: 2018-07-27 11:46:40
 *@author: jing.fu@gosafenet.com
 *@desc: 封装put请求
 */
export function put (url, options) {
  const data = Object.assign({}, options)

  Loading.open('请稍候')

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      axios.put(url, data)
        .then(response => {
          Loading.close()

          response !== undefined ? resolve(response.data) : resolve(null)

        }, err => {
          Loading.close()

          reject(err)
        })
    }, 1000)
  })
}



// WEBPACK FOOTER //
// ./src/common/HttpRequest.js